import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { permission } from 'src/app/data/permissions';
import Utils from 'src/app/helpers/utils';
import { GuardUtils } from 'src/app/guards/GuardUtils';
import { LoadingService } from 'src/app/services/Loading/loading.service';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  form = this.formBuilder.group({
    username: [null, [Validators.required]],
  });
  error = 'Campo inválido';
  valid: boolean = false;

  passwordForm = this.formBuilder.group({
    password: [null, [Validators.required, Validators.minLength(8)]],
  });
  newPasswordForm = this.formBuilder.group(
    {
      newPassword: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          (control: FormControl) => {
            const password = control.value;

            if (!this.hasNumber(password)) return { noNumber: true };
            if (!this.hasLowerCase(password)) return { noLowerCase: true };
            if (!this.hasUpperCase(password)) return { noUpperCase: true };
            if (!this.hasSpecialCharacter(password))
              return { noSpecialCharacter: true };

            return null;
          },
        ],
      ],
      confirmPassword: ['', [Validators.required]],
    },
    { validators: this.passwordsMatchValidator }
  );
  forgotModal: boolean = false;
  codeModal: boolean = false;

  loading = false;
  showSpinner = false;

  isAssignor = false;
  isCollaborator = false;
  isRepresentative = false;

  token = '';
  username = '';
  
  // Carbon Warning Modal properties
  showInvalidLinkModal = false;
  showLoggedInModal = false;
  
  // Flag para evitar redirecionamentos durante o logout
  private isLoggingOut = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private apiService: ApiService,
    public authService: AuthService,
    private toastService: ToastService,
    private activedRoute: ActivatedRoute,
    public loadingService: LoadingService,
    private storageService: StorageService,
    private guardUtils: GuardUtils
  ) {}

  ngOnInit(): void {
    // Se estiver fazendo logout, não fazer nada
    if (this.isLoggingOut) {
      return;
    }

    // Primeiro verifica os query params para saber se é colaborador ou representante
    const params = this.activedRoute.snapshot.queryParams;
    this.isCollaborator = params.type === 'collaborator';
    this.isRepresentative = params.representative === 'true';

    // Verificar se estamos em processo de logout na página de reset de senha
    // Se sim, não mostrar o modal e continuar normalmente
    const isLogoutInProgress = sessionStorage.getItem('@reset-password:logout-in-progress') === 'true';
    
    // Verificar se o usuário está autenticado (apenas se não estiver em processo de logout)
    if (!isLogoutInProgress && this.guardUtils.isAuthenticated()) {
      this.showLoggedInModal = true;
      return; // Não continua o fluxo normal se estiver logado
    }

    this.form.valueChanges.subscribe(({ username }) => {
      this.authService.forgotValue = username;
    });

    this.isAssignor = this.router.url.includes('assignor');

    this.activedRoute.queryParams.subscribe((params) => {
      // Verifica se é colaborador ou representante
      this.isCollaborator = params.type === 'collaborator';
      this.isRepresentative = params.representative === 'true';

      if (params.token && params.username) {
        const numbers = Utils.onlyNumbers(params.token);
        if (numbers.length < 4) {
          this.showInvalidLinkModal = true;
        } else {
          this.username = params.username;
          this.token = params.token;
        }
      } else {
        this.showInvalidLinkModal = true;
      }
    });
  }

  redirectUser(response: NewLoginResponse) {
    // Verifica se há parâmetro redirect na query string
    const redirect = this.activedRoute.snapshot.queryParamMap.get('redirect');

    if (redirect) {
      this.router.navigateByUrl(redirect).then(() => {
        // Esconde o loading após a navegação ser concluída
        setTimeout(() => {
          this.loadingService.hide();
          this.showSpinner = false;
        }, 500);
      });
      return;
    }

    if (response.is_staff) {
      this.router.navigateByUrl(`/app/dashboard`).then(() => {
        // Esconde o loading após a navegação ser concluída
        setTimeout(() => {
          this.loadingService.hide();
          this.showSpinner = false;
        }, 500);
      });
      return;
    }

    // if (response.active_register) {
    //   if (response.active_register.register.trace_step) {
    //     const {
    //       active_register: {
    //         register: {
    //           trace_step: { step_display },
    //           role,
    //           type,
    //           invite,
    //         },
    //       },
    //     } = response;

    //     // Determina o tipo (PF/PJ) com fallback para invite.data.person_type
    //     const finalType = 
    //       type ?? 
    //       (invite?.data?.person_type || 
    //        (invite?.data?.document && invite.data.Utils.isCnpjDocument(document) ? 'PJ' : 'PF'));

    //     // Determina o applicable (role) com fallback para invite.data.role
    //     const finalApplicable = 
    //       (role && role.applicable) ?? 
    //       invite?.data?.role;

    //     // Verifica se applicable e type existem antes de usar
    //     if (step_display === 'Cadastro' && finalApplicable && finalType && finalApplicable !== 'admin') {
    //       const registerId = response.active_register.register.id;
    //       const typeLower = finalType.toLowerCase();

    //       // Usa o register.id para redirecionar se existir
    //       const url = registerId
    //         ? `/signup/${finalApplicable}/${typeLower}/${registerId}`
    //         : `/signup/${finalApplicable}/${typeLower}`;

    //       this.router.navigateByUrl(url).then(() => {
    //         // Esconde o loading após a navegação ser concluída
    //         setTimeout(() => {
    //           this.loadingService.hide();
    //           this.showSpinner = false;
    //         }, 500);
    //       });

    //       return;
    //     }
    //   }
    // }

    this.router.navigateByUrl(`/app/dashboard`).then(() => {
      // Esconde o loading após a navegação ser concluída
      setTimeout(() => {
        this.loadingService.hide();
        this.showSpinner = false;
      }, 500);
    });
    return;
  }

  //   redirectUser(data: NewLoginResponse) {
  //     if (data.active_register.register.role.slug) {
  //       const role = data.active_register.register.role.slug.split('-');

  //       if (role[0] === 'ADM') {
  //         this.router.navigateByUrl(`/app/dashboard`);

  //         return;
  //       }
  //     }

  //     const url = this.isAssignor
  //       ? `/signup/assignor/${data.type.toLowerCase()}`
  //       : `/signup/${data.type.toLowerCase()}`;

  //     switch (data.trace_step.register_step) {
  //       case 'Dados complementares':
  //         this.router.navigateByUrl(url, {
  //           state: { step: 0 },
  //         });
  //         break;
  //       case 'Rendimentos & patrimônios':
  //         this.router.navigateByUrl(url, {
  //           state: { step: 1 },
  //         });
  //         break;
  //       case 'Deaclarações e autorizações':
  //         this.router.navigateByUrl(url, {
  //           state: { step: 2 },
  //         });
  //         break;
  //       case 'Análise de perfil de investidor':
  //         this.router.navigateByUrl(url, {
  //           state: { step: 3 },
  //         });
  //         break;
  //       case 'Declaração de Condição de Investidor':
  //         this.router.navigateByUrl(url, {
  //           state: { step: 4 },
  //         });
  //         break;
  //       case 'Informações Fiscais':
  //         this.router.navigateByUrl(url, {
  //           state: { step: 5 },
  //         });
  //         break;
  //       case 'Anexos & comprovantes':
  //         this.router.navigateByUrl(url, {
  //           state: { step: 6 },
  //         });
  //         break;
  //       case 'Análise':
  //         this.router.navigateByUrl(`/app/dashboard`);
  //         break;
  //       case 'Concluido':
  //         this.router.navigateByUrl(`/app/dashboard`);
  //         break;
  //       default:
  //         break;
  //     }
  //   }

  openModal() {
    this.forgotModal = true;
  }

  closeModal() {
    this.forgotModal = false;
  }

  hasLowerCase(str: string) {
    return str.toUpperCase() !== str;
  }

  hasUpperCase(str: string) {
    return str.toLowerCase() !== str;
  }

  hasSpecialCharacter(str: string) {
    return /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(str);
  }
  hasNumber(str: string) {
    return /\d/.test(str);
  }

  passwordsMatchValidator(formGroup: any) {
    const password = formGroup.get('newPassword')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;

    if (password && confirmPassword && password !== confirmPassword) {
      return { passwordsMismatch: true };
    }

    return null;
  }

  passwordsMatch(): boolean {
    const password = this.newPasswordForm.get('newPassword')?.value;
    const confirmPassword = this.newPasswordForm.get('confirmPassword')?.value;

    return password && confirmPassword && password === confirmPassword;
  }

  showPasswordMismatchError(): boolean {
    const confirmPasswordControl = this.newPasswordForm.get('confirmPassword');
    const formHasError = this.newPasswordForm.hasError('passwordsMismatch');

    return !!(confirmPasswordControl?.touched && formHasError);
  }

  passwordStrength(): number[] {
    const password = this.newPasswordForm.get('newPassword')?.value ?? '';

    const strengthSteps = [];

    if (password !== '') strengthSteps.push(0);
    if (password.length >= 8) strengthSteps.push(1);
    if (this.hasNumber(password)) strengthSteps.push(2);
    if (this.hasLowerCase(password) && this.hasUpperCase(password))
      strengthSteps.push(3);
    if (this.hasSpecialCharacter(password)) strengthSteps.push(4);

    return strengthSteps;
  }

  passwordStrengthPercentage(): number {
    return (100 * this.passwordStrength().length) / 5;
  }

  passwordStrengthText(): string {
    const percentage = this.passwordStrengthPercentage();

    if (percentage > 60 && percentage < 90) {
      return 'Sua senha precisa melhorar';
    } else if (percentage >= 90) {
      return 'Sua senha parece bem segura';
    }

    return 'Sua senha está fraca';
  }
  async sendPassword() {
    this.loading = true;
    // Mostra o loading spinner global durante todo o processo
    this.loadingService.show('Alterando senha e fazendo login...');

    const password = this.newPasswordForm.get('newPassword')?.value;
    const confirmPassword = this.newPasswordForm.get('confirmPassword')?.value;

    try {
      const payload = {
        username: this.username,
        token: this.token,
        password,
      };

      const response = await this.apiService.post({
        route: 'password-reset-complete/',
        body: payload,
      });

      this.toastService.show(
        'info',
        'Sucesso!',
        'Senha alterada com sucesso,Você será redirecionado'
      );

      if (response) {
        const { data } = await this.apiService.post<
          ApiResponse<NewLoginResponse>
        >({
          route: 'new-login/',
          body: { username: payload.username, password: payload.password },
        });

        this.storageService.setPermissionType(data.type_permission);

        let permissionsArr =
          data.active_register.permissions_role &&
          data.active_register.permissions_role.permissions
            ? data.active_register.permissions_role.permissions
            : [];

        // if (data.type_permission === 'owner') permissionsArr = permission;

        // if (window.location.href.includes('dev')) {
        //   permissionsArr = permission;
        // }

        this.authService.setToken(data.tokens.access);
        this.authService.setUser(data);

        // if (
        //   data.active_register.register.role.applicable === 'representative'
        // ) {
        //   const defaultPermissions: Permission[] = permission;

        //   permissionsArr = permissionsArr.concat(defaultPermissions);
        // }

        this.authService.permissions = permissionsArr;
        this.storageService.set('permissions', permissionsArr, true);

        // Mantém o loading até o redirecionamento
        this.loading = false;
        // O loading será escondido automaticamente quando a navegação acontecer
        // O spinner será escondido no redirectUser após a navegação
        this.redirectUser(data);
      }
    } catch (error: any) {
      console.error(error);
      this.loading = false;
      this.showSpinner = false;
      this.loadingService.hide();

      // Verificar se o erro é "Invalid token"
      const errorMessage = error?.error?.error || error?.error?.message || error?.message || '';
      const isInvalidToken = errorMessage.toLowerCase().includes('invalid token') || 
                             errorMessage.toLowerCase().includes('token inválido');

      if (isInvalidToken) {
        // Mostrar mensagem diferente para colaborador e não colaborador
        if (this.isCollaborator) {
          this.toastService.show(
            'warning',
            'Aviso',
            'Senha já criada para este colaborador com este link.',
            12000 // 12 segundos
          );
        } else {
          this.toastService.show(
            'warning',
            'Aviso',
            'Uma nova senha já foi cadastrada com este link.',
            12000 // 12 segundos
          );
        }
      } else {
        // Mostrar erro genérico se não for "Invalid token"
        const defaultMessage = error?.error?.error || error?.error?.message || 'Erro ao alterar senha. Tente novamente.';
        this.toastService.show(
          'error',
          'Erro',
          defaultMessage
        );
      }
    }
  }

  redirectToLogin() {
    this.router.navigateByUrl(`/login`);
  }

  // Carbon Warning Modal methods
  closeInvalidLinkModal() {
    this.showInvalidLinkModal = false;
    this.router.navigateByUrl(`/login`);
  }

  getInvalidLinkModalTitle() {
    return 'Link inválido!';
  }

  getInvalidLinkModalMessage() {
    return 'O link para recuperar senha é inválido ou expirou';
  }

  getInvalidLinkConfirmText() {
    return 'OK';
  }

  getInvalidLinkCancelText() {
    return 'Cancelar';
  }

  // Função para limpar apenas os dados de autenticação sem redirecionar
  private clearAuthDataOnly(): void {
    // Marcar que estamos em processo de logout na página de reset de senha
    // Isso evita que guards ou outros serviços redirecionem
    sessionStorage.setItem('@reset-password:logout-in-progress', 'true');
    
    // Remover apenas os itens críticos do localStorage
    const criticalKeys = ['@app:token', '@app:user', 'permissions', 'permission_type'];
    criticalKeys.forEach(key => {
      localStorage.removeItem(key);
    });

    // Limpar estado em memória do authService manualmente SEM emitir eventos
    // Usar a propriedade privada diretamente para evitar emitir userChange
    (this.authService as any)._user = undefined;
    (this.authService as any).token = undefined;
    this.authService.activeUser = undefined;
    this.authService.userTypePermission = '';
    this.authService.permissions = [];
    this.authService.navigationPermissions = [];
    this.authService.accountsArr = [];
  }

  // Métodos para o modal de usuário logado
  async confirmLogoutAndContinue() {
    // Fechar o modal primeiro
    this.showLoggedInModal = false;
    
    // Limpar apenas os dados de autenticação (sem usar logout completo que pode causar redirecionamentos)
    this.clearAuthDataOnly();
    
    // Aguardar um pouco para garantir que o storage foi limpo
    await new Promise((resolve) => setTimeout(resolve, 50));
    
    // Não recarregar a página - apenas continuar na mesma página
    // O componente já está carregado e pode continuar normalmente
    // Os query params já foram lidos no ngOnInit inicial, então não precisamos fazer nada mais
    // O usuário pode agora criar a senha normalmente
    
    // Remover a flag após um tempo para não interferir em outras operações
    setTimeout(() => {
      sessionStorage.removeItem('@reset-password:logout-in-progress');
    }, 1000);
  }

  cancelAndGoToDashboard() {
    this.showLoggedInModal = false;
    this.router.navigateByUrl('/app/dashboard');
  }

  getLoggedInModalTitle() {
    return this.isCollaborator 
      ? 'Olá colaborador' 
      : 'Você já está logado';
  }

  getLoggedInModalMessage() {
    return this.isCollaborator
      ? 'Para continuar com a criação da sua senha de acesso à plataforma, é necessário fazer logout. Deseja prosseguir?'
      : 'Para continuar com a recuperação de senha, é necessário fazer logout. Deseja prosseguir?';
  }

  getLoggedInConfirmText() {
    return this.isCollaborator
      ? 'Sim, deslogar e criar senha'
      : 'Sim, deslogar e continuar';
  }

  getLoggedInCancelText() {
    return 'Não, voltar ao dashboard';
  }
}
